<!-- eslint-disable no-unused-vars -->
<template>
  <div style="width: 100%">
    <el-table ref="wtyTableRef" border :fit="true" :data="tbList" size="mini" type="index" :height="wtytbheigh"
      class="show-table" style="height: 100%; width: calc(100% - 20px)" highlight-current-row
      :cell-style="{ padding: '0px 0' }" :header-cell-style="{
        height: '20px',
        background: '#409eff',
        color: '#fff',
      }" @row-click="rowClick">
      <el-table-column type="index" align="center" :width="50">
      </el-table-column>
      <el-table-column v-for="(item, index) in wtycolumnList" :key="index" :prop="item.prop" :align="item.align"
        :label="item.label" :width="item.width"
        :formatter="item.prop == 'mch_type' ? typeFormatter : typeFormattero"><!-- formatter 数据过滤 -->
      </el-table-column>

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text"
                ">
                  修改
                </el-button> -->
          <el-button @click.native.prevent.stop="showDetail(scope.$index, scope)" type="text">
            {{ operate }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="'验证'" :visible.sync="showdialog" width="500px" center>
      <el-form label-width="100px">
        <el-form-item label="密码：">
          <el-input show-password clearable placeholder="请输入密码进行验证：" v-model="pass_word"></el-input>
          <div v-if="who == 'swiftConfigure'" style="color: red">
            不输入密码可以获取店铺简略信息
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="" style="min-height: 40px !important">
        <el-button size="mini" type="primary" @click="dialogSureClick">确 定</el-button>
        <el-button size="mini" @click="showdialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { serviceQueryMerchant, serviceQueryProvider } from "@/api/service";

// eslint-disable-next-line no-unused-vars
import { aesEncrypt, aesDecrypt } from "@/js/Aes";
export default {
  name: "wty-table",
  /**
   * @param {array}wtytbList-表格数据
   * @param {array}wtycolumnList-表头数据
   * @param {number}wtytbheigh-表格高度
   * @param {string}operate-操作按钮的文字
   * @param {string}who-谁调用的组件
   */
  props: ["wtytbList", "wtycolumnList", "wtytbheigh", "operate", "who"],
  mounted() {
    // console.log("所有用户", this.wtytbList);
    // console.log("所有用户gggggggggggggggggggggggggggg", this.wtytbheigh);
    /* console.log("wtycolumn", this.wtycolumnList);
    console.log("wtytbList", this.wtytbList); */
    // console.log("wtycolumn", this.tbList);
    // console.log("wtytbList", this.alltbList);
  },
  data() {
    return {
      tbList: this.wtytbList,
      alltbList: this.wtytbList,
      showdialog: false,
      pass_word: "",
      loading: false,
      row: {}
    };
  },
  methods: {
    /**
     * 属性过滤器
     */
    typeFormatter(row, column, cellValue) {
      if (cellValue === "1") {
        return "付费商户";
      } else {
        return "免费商户";
      }
    },
    typeFormattero(row, column, cellValue) {
      return cellValue;
      // return row;
    },
    /**
     * 选中某一行触发的事件
     * @param {*} row 某一行的数据
     * @param {*} event
     * @param {*} column
     */
    rowClick(row, event, column) {
      this.$emit("updatePromiss", row);
    },
    deleteRow() { },
    hideRow() {
      this.$refs.wtyTableRef.setCurrentRow();
    },
    /**
     * 搜索
     * @param {string} key 父组件输入框传进来的值
     */
    wtyTableIn(key) {
      console.log("key--------------------=================", key);
      console.log("key--------------------=================", this.alltbList);
      this.tbList = [];
      if (key === "") {
        this.tbList = this.alltbList;
        return;
      }
      var _key = "";
      if (this.who === "createMerchant") {
        _key = "mch_name";
      } else if (this.who === "sonService") {
        _key = "service_name";
      }
      if (this.who === "mchPermission") {
        _key = "permission_name";
      }
      console.log("this.alltbList[0]", this.alltbList[0][_key]);
      console.log("this.alltbList[0].indexOf", this.alltbList[0][_key].indexOf(key));
      for (let i = 0; i < this.alltbList.length; i++) {
        if (this.alltbList[i][_key].indexOf(key) > -1) {
          this.tbList.push(this.alltbList[i]);
        }
      }
    },
    /**
     * 点击操作按钮触发
     * @param {number} index 点击操作按钮的行
     * @param {Object} param1 当前行的值
     */
    async showDetail(index, { row, ...a }) {
      //console.log("arguments================", arguments);
      switch (this.who) {
        case "swiftConfigure":
          this.row = row;
          this.showdialog = true;
          return;
        case "peoplepermisslist":
        case "servicepermisslist":
        case "shoppermisslist":
        case "peopleinfo":
        case "shoppermission":
        case "permission":
          this.$emit("deleteRow", row);
          return;
        case "mchPermission":
          this.$emit("wtyTbreturn", row);
          return;
        default:
          /**
           * 高亮显示
           */
          this.row = row;
          this.$refs.wtyTableRef.setCurrentRow(row);
          if (!localStorage.getItem("pass_word")) {
            this.showdialog = true;
          } else {
            this.getInfo();
          }
          break;
      }
      //TODO:改成switch 格式
      /* if (this.who == "swiftConfigure") {
        this.row = row;
        this.showdialog = true;
        return;
      }
      if (
        this.who == "peoplepermisslist" ||
        this.who == "servicepermisslist" ||
        this.who == "shoppermisslist" ||
        this.who == "peopleinfo" ||
        this.who == "shoppermission" ||
        this.who == "permission"
      ) {

        //删除行
        this.$emit("deleteRow", row);
        return;
      } */
    },
    /**
     * 输入密码，并点击确认按钮
     */
    async dialogSureClick() {
      localStorage.setItem("pass_word", this.pass_word);
      this.showdialog = false;
      this.getInfo();
    },
    /**
     * this.who==("createMerchant"|"sonService"|"swiftConfigure") 获取对应的值
     */
    async getInfo() {
      if (this.who === "createMerchant") {
        const res = await serviceQueryMerchant(this.row.merchant_id);
        console.log("获取返回值-----------", res);
        //这个接口返回值没有result_code
        var { ...data } = res;
        console.log("data----------------", data);
        const key = this.$md5(localStorage.getItem("access_token"));
        data.license_code = aesDecrypt(data.license_code, key);
        data.mobile_no = aesDecrypt(data.mobile_no, key);

        data.merchant_id = this.row.merchant_id;
        console.log("要传递回去的数据", data);
        this.$emit("wtyTbreturn", data);
      } else if (this.who === "sonService") {
        const res = await serviceQueryProvider(this.row.service_no);
        if (
          this.testR(res) &&
          res.data.return_code === "SUCCESS" &&
          res.data.resp_data
        ) {
          // eslint-disable-next-line no-redeclare
          var { ...data } = res.data.resp_data;
          // console.log(res.data.resp_data);
          /* if (!localStorage.getItem("pass_word")) {
            this.warnMessage("请输入密码,进行进一步验证!");
          } else {
            const key = this.$md5(this.$md5(localStorage.getItem("pass_word")));
            data.license_code = aesDecrypt(data.license_code, key);
            data.mobile_no = aesDecrypt(data.mobile_no, key);
          }
          data.merchant_id = this.row.merchant_id; */
          this.$emit("wtyTbreturn", data);
        }
      } else if (this.who === "swiftConfigure") {
        this.row.pass_word = this.pass_word;
        this.$emit("wtyTbreturn", this.row);
      }
    },
    setpeopleList(res) {
      this.tbList = res;
    },
    CancelHighLight() {
      this.$refs.wtyTableRef.setCurrentRow();
    }
  }
}
</script>
<style lang="less" scoped>
* {
  user-select: text;
}

.el-dialog__footer {
  min-height: 40px !important;
}
</style>
